module.exports = __webpack_public_path__ + "static/media/FEELER.d9026105.webm";